import { render } from "./ManagementRetributionView.vue?vue&type=template&id=68b687e5"
import script from "./ManagementRetributionView.vue?vue&type=script&lang=js"
export * from "./ManagementRetributionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__